import httpClient from "../../http";

export const download = function (url) {
    return new Promise((resolve, reject) => {
        httpClient.get(url, { responseType: 'blob'}).then((response) => {
            const blob = new Blob([response.data]);
            const link = document.createElement('a');
            const filename = decodeURIComponent(response.headers["content-disposition"].split("'")[2]);
            link.href = URL.createObjectURL(blob);
            link.setAttribute('download', filename);
            link.click();
            URL.revokeObjectURL(link.href);
            resolve(response)
        }).catch((reason) => {
            reject(reason)
        });
    })
};